import React from 'react'
import Helmet from 'react-helmet'
import {useCustomPreference} from '../../hooks/use-custom-preference'

const DynamicHider = () => {
    const dynamicHiderConfig = useCustomPreference('dynamicHiderConfiguration')

    if (!dynamicHiderConfig?.selectors) {
        return null
    }

    const selectors = (
        Array.isArray(dynamicHiderConfig.selectors)
            ? dynamicHiderConfig.selectors
            : typeof dynamicHiderConfig.selectors === 'string'
            ? dynamicHiderConfig.selectors.split(',')
            : []
    )
        .map((s) => s.trim())
        .filter(Boolean)

    if (selectors.length === 0) {
        return null
    }

    return (
        <Helmet>
            <style id="dynamic-hider" type="text/css">{`${selectors.join(
                ', ',
            )} { display: none !important; }`}</style>
        </Helmet>
    )
}

export default DynamicHider
